import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { getClassName } from "../../../../components/Converter";
import Degree from "../../../../components/Math/Units/Metric/Degree";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { decimalSeparator, thousandSeparator } from "../../../../i18n";
import {
  selectPileInclinationFromVertical,
  setPileInclinationFromVertical,
} from "../../../../store/slices/fhwaSlice";

function PileInclination() {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();
  const pileInclinationFromVertical = useSelector(selectPileInclinationFromVertical);
  return (
    <RowBody
      titleValue={<p>{t("aashto.inner.Pile inclination to the vertical")}</p>}
      indicesValue={<span>&beta;</span>}
      inputValue={
        <span className="change-input">
          <NumberFormat
            className={getClassName(pileInclinationFromVertical)}
            value={pileInclinationFromVertical}
            decimalSeparator={decimalSeparator()}
            thousandSeparator={thousandSeparator()}
            displayType="input"
            type="text"
            onValueChange={(value) => {
              dispatch(setPileInclinationFromVertical(value.floatValue ?? 0));
            }}
            allowNegative={true}
          />
        </span>
      }
      unitValue={<Degree />}
    />
  );
}

export default PileInclination;
